import { getBounds, ILocation } from "@sp-crm/core";
import { MapMarkerId } from "components/community-search/community-map/types";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import * as React from "react";
import Map, { NavigationControl, ScaleControl } from "react-map-gl/maplibre";
import { NextgenMapMarker } from "../community-search/community-map/nextgen-marker";
import { MapErrorBoundary } from "./map-error-boundary";
import { MarkerIconColor } from "./types";

interface NextgenStaticMapProps {
    entityId: MapMarkerId;
    location: ILocation | null;
    iconType: MarkerIconColor;
    hideControls?: boolean;
    grayscale?: boolean;
    zoom?: number;
}

export const NextgenStaticMap: React.FC<NextgenStaticMapProps> = props => {
    const {
        location,
        entityId,
        iconType,
        hideControls = false,
        grayscale = false,
        zoom,
    } = props;

    if (!location) {
        return <span />;
    }

    return (
        <MapErrorBoundary>
            <div style={{ position: "relative", height: 200 }}>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        filter: grayscale
                            ? "grayscale(100%) sepia(20%) hue-rotate(160deg) saturate(120%) brightness(95%)"
                            : "none",
                        pointerEvents: "none",
                    }}>
                    <Map
                        mapLib={maplibregl}
                        attributionControl={false}
                        initialViewState={{
                            ...(zoom
                                ? {
                                      longitude: location.loc[0],
                                      latitude: location.loc[1],
                                      zoom,
                                  }
                                : {
                                      bounds: getBounds([location]),
                                      fitBoundsOptions: { maxZoom: 13 },
                                  }),
                        }}
                        style={{ height: 200 }}
                        mapStyle="https://api.maptiler.com/maps/8d80423a-4979-4e17-a487-ce521f75ff8e/style.json?key=Xs35dG5Gh6ueSw4mF06I">
                        {!hideControls && <NavigationControl position="top-left" />}
                        {!hideControls && <ScaleControl />}
                    </Map>
                </div>
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        pointerEvents: "none",
                    }}>
                    <Map
                        mapLib={maplibregl}
                        attributionControl={false}
                        interactive={false}
                        initialViewState={{
                            ...(zoom
                                ? {
                                      longitude: location.loc[0],
                                      latitude: location.loc[1],
                                      zoom,
                                  }
                                : {
                                      bounds: getBounds([location]),
                                      fitBoundsOptions: { maxZoom: 13 },
                                  }),
                        }}
                        style={{ height: 200, background: "transparent" }}>
                        <NextgenMapMarker
                            id={entityId}
                            isHovered={false}
                            iconType={iconType}
                            location={location}
                        />
                    </Map>
                </div>
            </div>
        </MapErrorBoundary>
    );
};
